// Public membership lookup — PRIVACY FIRST.
// Only non-sensitive fields are ever selected/exposed:
// membership_no, full_name, unit_slug, membership_type, status, joined_year.

import { supabase } from "@/lib/supabaseClient";
import { checkSupabaseReady } from "./dataClient";
import { crudFor } from "./dataClient";
import { seedMembers } from "@/data/seed/members";

const PUBLIC_FIELDS = "id, membership_no, full_name, unit_slug, membership_type, status, joined_year";
const MAX_RESULTS = 20;

export const membersCrud = crudFor("members", seedMembers);

export const membersService = {
  async search({ query, unitSlug }) {
    const q = (query || "").trim();
    if (q.length < 3) return { results: [], tooShort: true };

    const live = await checkSupabaseReady();
    if (live) {
      let request = supabase
        .from("members")
        .select(PUBLIC_FIELDS)
        .or(`membership_no.ilike.%${q}%,full_name.ilike.%${q}%`)
        .limit(MAX_RESULTS);
      if (unitSlug && unitSlug !== "All") request = request.eq("unit_slug", unitSlug);
      const { data, error } = await request;
      if (!error && data) return { results: data, tooShort: false };
    }

    const lower = q.toLowerCase();
    const results = seedMembers
      .filter(
        (m) =>
          (m.membership_no.toLowerCase().includes(lower) ||
            m.full_name.toLowerCase().includes(lower)) &&
          (!unitSlug || unitSlug === "All" || m.unit_slug === unitSlug)
      )
      .slice(0, MAX_RESULTS);
    return { results, tooShort: false };
  },

  async count() {
    const live = await checkSupabaseReady();
    if (live) {
      const { count, error } = await supabase
        .from("members")
        .select("id", { count: "exact", head: true });
      if (!error && count !== null) return count;
    }
    return seedMembers.length;
  },
};
